import React from "react";
import Wrapper from "@/scenes/_shared/stages/wrapper";
import useStringInput, { StringInput } from "@/components/form/string-input";
import useTextInput, { TextInput } from "@/components/form/text-input";
import useRadioInput, { RadioInput } from "@/components/form/radio-input";
import useToggleInput, { ToggleInput } from "@/components/form/toggle-input";
import Label from "@/components/form/label";

const S07 = (props) => {
    const prepurchase = useRadioInput({
        name: "sale[info][prepurchase]",
        label: "Hvilke opplysninger hadde du ved kjøpet?",
        tooltip: "Du kan velge flere alternativer.",
        options: {
            data: [
                { label: "Finn-annonse", value: "AD" },
                { label: "Undersøkelse fra verksted/naf-test før kjøp", value: "PROFESSIONAL_INSPECTION" },
                { label: "Prøvekjøring", value: "TEST_DRIVE" },
                { label: "Visuell fysisk befaring", value: "PHYSICAL_INSPECTION" },
                { label: "Annet", value: "OTHER" },
            ],
        },
        multiple: true,
        required: false,
        ...props,
    })

    const text = useTextInput({
        name: "sale[info][other]",
        placeholder: "Hvilken andre opplysninger hadde du?",
        ...props,
    })

    const toggle = useToggleInput({
        name: "sale[info][hasUrl]",
        label: "Nei",
        className: "form__radio flex--grow",
        required: false,
        ...props,
    })

    const url = useStringInput({
        name: "sale[info][url]",
        placeholder: "Lim inn lenken",
        tooltip: "Har du lagret annonsen som favoritt, kan du fortsatt finne den selv om den er deaktivert.",
        className: "flex--grow",
        required: false,
        ...props,
        disabled: props?.disabled || !prepurchase.is("AD") || toggle.is(true),
    })

    return (
        <Wrapper {...props} header="Opplysninger om kjøpet">
            <div className="group--flex gg-3">
                <RadioInput {...prepurchase.props}/>
            </div>

            { prepurchase.is("AD") &&
                <>
                    <div className="mt-7">
                        <Label
                            {...url.props.label}
                            label="Har du lenke til finn-annonsen?"
                            tooltip={url.props.tooltip}
                            options={url.props.options}
                            data-type="inline"
                        />
                    </div>
                    <div className="group--flex gg-3">
                        <ToggleInput {...toggle.props}/>
                        <StringInput {...url.props} style={{ minWidth: "150px" }}/>
                    </div>
                </>
            }

            { prepurchase.is("OTHER") && <TextInput {...text.props} className="mt-4"/> }
        </Wrapper>
    );
};

export default S07;
